import React, { Component } from "react";
import axios from "axios";
import * as PropTypes from "prop-types";
import { Form, Input, message, Modal, Tabs } from "antd";
import { IMask } from 'react-imask';
import { debounce } from 'lodash';
import moment from "moment";
import { API_ERRO_TYPE_CANCEL } from "./../../config/general";
import { employeesService, perimetersService } from "../../redux/services";
import ModalDepartmentCreate from "./departmentCreate";
import ModalFunctionsCreate from "./functionCreate";
import ModalDepartmentsHistory from "./departmentsHistoryShow";
import Adresses from "./Adresses"
import Contracts from "./Contracts"
import Contacts from "./Contacts"
import { checkIfAvatarIsValid } from "../../utils/checkAvatar";
import defaultAvatar from '../../images/default-profile.png';
import {
	UIDrawerForm,
	UISteps,
} from "./../../components";
import {
	STEP_FIELDS,
	EmployeeAppFields,
	EmployeeEquipmentsFields,
	EmployeeGeneralFields,
} from "./create";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

export const STEPS = [
	{ key: "general", label: "Informações gerais", icon: <i className="fal fa-user" /> },
	{ key: "contracts", label: "Contratos", icon: <i className="fal fa-briefcase" /> },
	{ key: "app", label: "Parâmetros REP-P", icon: <i className="fal fa-mobile-alt" /> },
	{ key: "equipments", label: "Credenciais REP-C", icon: <i className="fal fa-fingerprint" /> },
	{ key: "adresses", label: "Endereços", icon: <i className="fal fa-map-marker-alt" /> },
	{ key: "contacts", label: "Contatos", icon: <i className="fal fa-address-book" /> },
];

const tabLabel = (key) => {
	const step = STEPS.find((item) => item.key === key);

	return <span className="tab-icon-label">{step.icon} {step.label}</span>;
};

class ModalEdit extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			uuid: null,
			companiesIsLoading: false,
			isLoading: false,
			isSending: false,
			nextOrder: 1,
			selectedAnnualLeave: { descricao: null, id: null, uuid: null },
			selectedJourney: { descricao: null, id: null, uuid: null },
			selectedFunction: null,
			selectedDepartment: null,
			type: null,
			contractsHistory: [],
			hasActiveContract: false,
			activeKey: "general",

			companies: [],
			departmentsHistory: [],
			annualLeaveIsLoading: false,
			annualLeave: [],
			departmentsIsLoading: false,
			departments: [],
			functionsIsLoading: false,
			functions: [],
			journeysIsLoading: false,
			journeys: [],
			perimetersIsLoading: false,
			perimeters: [],
			displayParamsREPP: true,
			displayAppCompany: true,
			displayAppEmployee: true
		};

		this._axiosCancelToken = null;
	}

	componentDidMount() {
		this.handleCheckCompanyHasAccessREPP();
	}

	/**
	 * Show
	 *
	 * @param uuid
	 */
	journeyShowOpen = () => {
		this.setState({ journeyShowModalVisible: true });
		// On open screen
		if (this.state.selectedJourney.descricao != null) {
			this.journeyShowScreen.onOpen(this.state.selectedJourney.uuid);
		} else {
			this.journeyShowScreen.onOpen(this.state.journeys.filter((journey) => journey.id == this.state.selectedJourney.id)[0].uuid);
		}

	};

	journeyShowOnClose = () => {
		this.setState({ journeyShowModalVisible: false });
	};

	/**
	 * Show
	 *
	 * @param uuid
	 */
	annualLeaveShowOpen = ({ uuid }) => {
		this.setState({ annualLeaveShowModalVisible: true });

		// On open screen
		if (this.state.selectedAnnualLeave.descricao != null) {
			this.annualLeaveShowScreen.onOpen(this.state.selectedAnnualLeave.uuid);
		} else {
			this.annualLeaveShowScreen.onOpen(this.state.annualLeave.filter((annual) => annual.id == this.state.selectedAnnualLeave.id)[0].uuid);
		}
	};

	annualLeaveShowOnClose = () => {
		this.setState({ annualLeaveShowModalVisible: false });
	};

	/**
	  * Department Create
	  */
	departmentCreateOpen = () => {
		this.setState({ departmentCreateModalVisible: true });

		// On open screen
		this.departmentCreateScreen.onOpen();
	};

	departmentCreateOnClose = () => {
		this.setState({ departmentCreateModalVisible: false });
	};

	departmentCreateOnComplete = (item) => {
		this.setState({ departmentCreateModalVisible: false });

		this.form.setFieldsValue({ departamento_id: item.id })
		this.setState({ selectedDepartment: item.nome })
	};

	/**
	  * Function Create
	  */
	functionCreateOpen = () => {
		this.setState({ functionCreateModalVisible: true });

		// On open screen
		this.functionCreateScreen.onOpen();
	};

	functionCreateOnClose = () => {
		this.setState({ functionCreateModalVisible: false });
	};

	functionCreateOnComplete = (item) => {
		this.setState({ functionCreateModalVisible: false });

		this.form.setFieldsValue({ funcao_id: item.id })
		this.setState({ selectedFunction: item.nome })
	};

	fetchPerimeters = (value) => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		// if (value !== undefined && !value.trim().length) {
			// this.setState({
				// perimetersIsLoading: false,
				// perimeters: [],
			// });

			// return false;
		// }

		this.setState({
			perimetersIsLoading: true,
		});

		perimetersService.getAutocomplete({
			...(value ? { search: value } : {}),
			status: 1,
			cancelToken: this._axiosCancelTenantsToken.token,
		})
			.then((response) => {
				this.setState({
					perimetersIsLoading: false,
					perimeters: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					perimetersIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchPerimetersSearch = debounce(this.fetchPerimeters, 500);

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			uuid: uuid,
			activeKey: "general",
		});

		employeesService.show({ uuid })
			.then((response) => {

				let item = response.data.data;

				let companies = [];
				let departments = [];
				let functions = [];
				let perimeters = [];

				// if (item.contrato == null) {
				// 	const current_contract = response.data.historico_contratos[response.data.historico_contratos.length - 1];
				// 	item.contrato = current_contract;
				// }

				// if (item.contrato) {

				// 	if (item.contrato.empresa) {
				// 		companies.push({
				// 			id: item.contrato.empresa.id,
				// 			nome: item.contrato.empresa.nome,
				// 		});
				// 	}

				// 	if (item.contrato.funcoes) {
				// 		functions.push({
				// 			id: item.contrato.funcoes.id,
				// 			nome: item.contrato.funcoes.nome,
				// 		});
				// 	}

				// 	if (item.contrato.departamento) {
				// 		departments.push({
				// 			id: item.contrato.departamento.id,
				// 			nome: item.contrato.departamento.nome,
				// 		});
				// 	}
				// }


				if (item.perimetro) {
					perimeters.push({
						id: item.perimetro.id,
						nome: item.perimetro.nome,
					});
				}

				item.departmentsHistory = response.data.historico_departamentos;

				this.setState({
					departmentsHistory: response.data.historico_departamentos,
					contractsHistory: response.data.historico_contratos,
					isLoading: false,
					companies: companies,
					departments: departments,
					functions: functions,
					perimeters: perimeters,
				}, () => {
					// Fill form
					this.fillForm(item);

					if (item.avatar) {
						const file = {
							uuid: item.uuid,
							url: item.avatar,
							type: 'image/jpeg',
						}

						this.upload.setFiles([file]);

						// removido por enquanto
						// checkIfAvatarIsValid(item.avatar).then(res => {
						// 		if (res.status !== 200) {
						// 			file.url = defaultAvatar;
						// 			this.upload.setFiles([file]);
						// 			return;
						// 		}

						// 		this.upload.setFiles([file]);
						// 	}).catch(_ => {
						// 		file.url = defaultAvatar;
						// 		this.upload.setFiles([file]);
						// 	});
					}

					this.tabAdresses && this.tabAdresses.init(item);
					this.tabContacts && this.tabContacts.init(item);
					this.tabContracts && this.tabContracts.init(item);
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
	};

	fillForm = (data) => {
		this.form.setFieldsValue({
			nome: data.nome,
			ativo: data.ativo,
			cpf: data.cpf,
			ctps: data.ctps,
			perimetro_id: data.perimetro ? data.perimetro.id : null,
			data_nascimento: data.data_nascimento ? moment(data.data_nascimento) : null,
			email: data.email,
			habilitar_app_empresa: data.habilitar_app_empresa ?? null,
			permitir_registro_app: data.permitir_registro_app ?? null,
			permitir_assinar_cartao_app: data.permitir_assinar_cartao_app ?? null,
			exigir_senha_assinatura: data.exigir_senha_assinatura ?? null,
			permitir_justificativa_parcial_app: data.permitir_justificativa_parcial_app ?? null,
			justificativa_parcial_app_auto_aprovar: data.justificativa_parcial_app_auto_aprovar ?? null,
			app: data.app ?? null,
			equipamento_admin: data.equipamento_admin,
			envio_self: data.envio_self ?? null,
			equipamento_biometria: data.equipamento_biometria,
			equipamento_codigo_barras: data.equipamento_codigo_barras,
			equipamento_enviar_rfid: data.equipamento_enviar_rfid,
			equipamento_rfid: data.equipamento_rfid,
			equipamento_senha: data.equipamento_senha,
			nacionalidade: data.nacionalidade,
			naturalidade: data.naturalidade,
			pin: data.pin,
			sexo: data.sexo,
			nome_mae: data.nome_mae,
			arquivar: data.contrato ? data.contrato.arquivar : null,
			nome_pai: data.nome_pai,
			numero_folha: data.numero_folha,
			numero_identificador: data.numero_identificador,
			pis_pasep: IMask.pipe((data.pis_pasep ?? ''), {mask: '000.00000.00-0'}),
			rg: data.rg,
			rg_data_expedicao: data.rg_data_expedicao ? moment(data.rg_data_expedicao) : null,
			rg_ssp: data.rg_ssp,
			password: '******'
		});
	};

	handleContractsLoaded = (contracts) => {
		this.setState({
			hasActiveContract: (contracts || []).some((contract) => contract.arquivar == 0),
		});
	};

	resetFields = () => {
		this.form.resetFields();
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onFinish = (values) => {
		const file = this.upload.getFiles();

		if (file.hasError) {
			Modal.error({
				title: "Ocorreu um erro!",
				content: file.error,
			});

			return false;
		}

		this.setState({
			isSending: true,
		});

		const { uuid } = this.state;

		const data = {
			...values
		};

		// uuid
		data.uuid = uuid;

		if (data.data_demissao) {
			data.data_demissao = data.data_demissao.format("YYYY-MM-DD");
		}

		if (data.data_admissao) {
			data.data_admissao = data.data_admissao.format("YYYY-MM-DD");
		}

		if (data.data_inicio_cartao_ponto) {
			data.data_inicio_cartao_ponto = data.data_inicio_cartao_ponto.format("YYYY-MM-DD");
		}

		if (data.data_nascimento) {
			data.data_nascimento = data.data_nascimento.format("YYYY-MM-DD");
		}

		if (data.rg_data_expedicao) {
			data.rg_data_expedicao = data.rg_data_expedicao.format("YYYY-MM-DD");
		}

		if (file.files.length) {
			if (!file.files[0].uuid) {
				data.avatar = file.files[0];
			}
		} else {
			data.avatar = null;
		}

		data.pis_pasep = (data.pis_pasep || '').replaceAll('.', '').replace('-', '');

		if (!data.password || data.password.length < 6 || data.password === '******') {
			delete data.password;
		}

		employeesService.edit(data)
			.then((response) => {
				this.setState({
					isSending: false,
				});

				// Reset fields
				this.resetFields();

				// Success message
				message.success("Registro atualizado com sucesso.");

				// Callback
				this.props.onComplete();
			})
			.catch((data) => {
				this.setState({
					isSending: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	handleCheckCompanyHasAccessREPP = () => {
		const companyData = JSON.parse(localStorage.getItem('@mainCompany'));

		this.setState({
			displayParamsREPP: !(!companyData?.app_empresa && !companyData?.app_funcionario),
			displayAppCompany: companyData?.app_empresa,
			displayAppEmployee: companyData?.app_funcionario
		});
	}

	onFinishFailed = ({ errorFields }) => {
		const field = errorFields[0]?.name[0];
		const step = Object.keys(STEP_FIELDS).find((key) => STEP_FIELDS[key].includes(field));

		if (step && step !== this.state.activeKey) {
			this.setState({ activeKey: step }, () => this.form.scrollToField(field));
		}
	};

	render() {
		const { visible } = this.props;

		const {
			isLoading,
			isSending,
			perimeters,
			perimetersIsLoading,
			displayParamsREPP,
			displayAppCompany,
			displayAppEmployee,
			hasActiveContract,
			activeKey,
		} = this.state;

		const steps = STEPS.filter((step) => step.key !== "app" || displayParamsREPP);

		return (
			<UIDrawerForm
				visible={visible}
				width={1100}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				icon={<i className="fal fa-users" />}
				title="Editar funcionário"
				subtitle="Atualize os dados do funcionário. Empresa, departamento, função e horário são alterados na aba Contratos."
				footer={
					<UISteps
						steps={steps}
						current={activeKey}
						onChange={(key) => this.setState({ activeKey: key })}
						onCancel={this.onClose}
					/>
				}>
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinishFailed={this.onFinishFailed}
					onFinish={this.onFinish}>
					<Tabs
						activeKey={activeKey}
						onChange={(key) => this.setState({ activeKey: key })}
					>
						<Tabs.TabPane forceRender tab={tabLabel("general")} key="general">
							<EmployeeGeneralFields
								uploadRef={el => this.upload = el}
								nomeRef={el => this.nome = el}
								statusLocked={hasActiveContract}
							/>
						</Tabs.TabPane>
						<Tabs.TabPane forceRender tab={tabLabel("contracts")} key="contracts">
							<Contracts
								onEditContract={() => {
									this.props.onComplete();
								}
								}
								onContractsLoaded={this.handleContractsLoaded}
								ref={el => this.tabContracts = el}
							/>
						</Tabs.TabPane>
						{displayParamsREPP && (
							<Tabs.TabPane forceRender tab={tabLabel("app")} key="app">
								<EmployeeAppFields
									displayAppEmployee={displayAppEmployee}
									displayAppCompany={displayAppCompany}
									perimeters={perimeters}
									perimetersIsLoading={perimetersIsLoading}
									onPerimetersDropdownVisibleChange={(open) => open && this.fetchPerimeters()}
									onPerimetersSearch={this.fetchPerimetersSearch}
									passwordInput={<Input.Password visibilityToggle={false} minLength={6} />}
								/>
							</Tabs.TabPane>
						)}
						<Tabs.TabPane forceRender tab={tabLabel("equipments")} key="equipments">
							<EmployeeEquipmentsFields />
						</Tabs.TabPane>
						<Tabs.TabPane forceRender tab={tabLabel("adresses")} key="adresses">
							<Adresses
								ref={el => this.tabAdresses = el}
							/>
						</Tabs.TabPane>
						<Tabs.TabPane forceRender tab={tabLabel("contacts")} key="contacts">
							<Contacts
								ref={el => this.tabContacts = el}
							/>
						</Tabs.TabPane>
					</Tabs>
				</Form>
				<ModalDepartmentCreate
					ref={el => this.departmentCreateScreen = el}
					visible={this.state.departmentCreateModalVisible}
					onComplete={this.departmentCreateOnComplete}
					onClose={this.departmentCreateOnClose}
				/>
				<ModalFunctionsCreate
					ref={el => this.functionCreateScreen = el}
					visible={this.state.functionCreateModalVisible}
					onComplete={this.functionCreateOnComplete}
					onClose={this.functionCreateOnClose}
				/>
				<ModalDepartmentsHistory
					ref={el => this.departmentsHistoryShowScreen = el}
					visible={this.state.departmentsHistoryShowModalVisible}
					onClose={this.departmentsHistoryShowOnClose}
				/>
			</UIDrawerForm>
		)
	}
}

export default ModalEdit;
